<template>
  <div id="news">
    <div class="w-container">
      <h1>
        <strong>{{ $t("home.news") }}</strong>
      </h1>
      <div class="w-row news-row">
        <router-link
          :to="{
            name: 'news-details',
            params: { slug: item.slug, locale: $i18n.locale },
          }"
          class="news-item w-col w-col-3 w-col-small-12 w-col-tiny-12"
          v-for="item in newsList"
          :data="item"
          :key="item.id"
        >
          <div
            :style="{ backgroundImage: 'url(' + item.front_page_image + ')' }"
            class="image"
          ></div>
          <div class="date">{{ item.date }}</div>
          <div class="title">{{ item.title }}</div>
          <div class="description">{{ item.short_description }}</div>
          <div class="more">{{ $t("home.readMore") }}</div>
          <!--<div class="more" v-if="item.id === 3"><a href="/imn-national" target="_blank">descarcă</a></div>-->
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "News",
  data() {
    return {
      newsList: [],
    };
  },
  methods: {
    handleNewsListLoad(response) {
      this.newsList = response.data.reverse();
    },
  },
  mounted() {
    this.$http
      .get("news/")
      .then((response) => this.handleNewsListLoad(response));
  },
};
</script>

<style scoped>
#news {
  background: #354e61;
  padding: 150px 0 180px 0;
}

h1 {
  color: #fff;
  text-transform: uppercase;
  font-size: 3em;
  text-align: center;
  margin-bottom: 100px;
}

.title {
  margin-top: 0px;
  margin-bottom: 10px;
  padding-left: 10px;
  color: #3d5262;
  font-size: 1.7em;
  font-weight: 700;
  text-transform: uppercase;
  overflow: hidden;
  line-height: 1.1em;
  height: 3.3em;
}

.description {
  margin-bottom: 32px;
  padding-right: 24px;
  padding-left: 10px;
  color: #525455;
  font-size: 1.1em;
  line-height: 1.4em;
  height: calc(5 * 1.4em);
  overflow: hidden;
}

.date {
  margin-top: 25px;
  margin-bottom: 25px;
  padding-left: 10px;
  color: #525455;
  font-size: 1em;
}

.news-item {
  border-radius: 5px;
  position: relative;
  padding: 30px 30px 70px 30px;
  width: calc(33.333333% - 30px);
  margin: 15px;
  text-decoration: none;
}

@media (max-width: 767px) {
  .news-item {
    width: calc(100% - 30px);
    margin-bottom: 15px;
  }

  #news {
    padding: 75px 0 60px 0;
  }
}

.news-item {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  border: 1px none #ededed;
  border-radius: 3px;
  background-color: #fff;
  -webkit-transition: all 708ms ease;
  transition: all 708ms ease;
}

.news-item:hover {
  box-shadow: 0 9px 90px -1px rgba(32, 47, 58, 0.85);
  -webkit-transform: translate(0px, -9px);
  -ms-transform: translate(0px, -9px);
  transform: translate(0px, -9px);
}

.image {
  width: 100%;
  height: 200px;
  background-size: cover;
  background-position: center;
}

.more {
  position: absolute;
  bottom: 0;
  right: 0;

  padding: 15px 58px;
  border-bottom-right-radius: 3px;
  background-color: #e7e7e7;
  color: #7a8994;
  font-size: 1.2em;
  font-weight: 400;
  letter-spacing: 1.2px;
}

.more a {
  color: #7a8994;
  text-decoration: none;
}

.news-item:hover .more {
  transition: 0.3s;
}

.news-item:hover .more {
  background-color: #2d4557;
  color: #fff;
}
</style>
